import { api } from '../../lib/api';
import type { CampaignRow, GrantQuotaPayload, QuotaGrant, UserQuotaGrants } from './types';

export function fetchUserQuotaGrants(userId: string): Promise<UserQuotaGrants> {
  return api.get<UserQuotaGrants>(`/admin/users/${userId}/quota-grants`);
}

export function fetchCampaigns(): Promise<{ campaigns: CampaignRow[] }> {
  return api.get<{ campaigns: CampaignRow[] }>('/admin/quota-grants/campaigns');
}

/** Vergabe für EINEN oder VIELE Nutzer — bewusst ein Aufruf.
 *  `requireStepUp` verbraucht ein Einmal-Token pro Aufruf; eine Schleife über
 *  Einzelaufrufe hieße n-mal 2FA (der Grund, aus dem CUR-470 als Skript endete). */
export function grantQuota(
  payload: GrantQuotaPayload,
  stepUpToken: string,
): Promise<{ grants: QuotaGrant[] }> {
  return api.post<{ grants: QuotaGrant[] }>('/admin/quota-grants', payload, { stepUpToken });
}

export function revokeQuotaGrant(id: string, reason: string, stepUpToken: string): Promise<void> {
  return api.delete<void>(`/admin/quota-grants/${id}`, {
    body: JSON.stringify({ reason }),
    stepUpToken,
  });
}
